import { Box, type SxProps, type Theme, Typography } from '@mui/material';

export type LabeledBar = Readonly<{ id: string; label: string; pct: number }>;

export type LabeledBarListProps = Readonly<{ bars: readonly LabeledBar[] }>;

/** Horizontal percent bars, one labelled row each. */
export const LabeledBarList = ({ bars }: LabeledBarListProps) => (
  <Box sx={listSx}>
    {bars.map((bar) => (
      <Box key={bar.id} sx={itemSx}>
        <Typography variant="text-sm-medium" sx={labelSx}>
          {bar.label}
        </Typography>
        <Box sx={rowSx}>
          <Box sx={trackSx}>
            <Box sx={fillSx} style={{ width: `${bar.pct}%` }} />
          </Box>
          <Typography variant="text-sm-semibold" sx={valueSx}>
            {`${bar.pct}%`}
          </Typography>
        </Box>
      </Box>
    ))}
  </Box>
);

const listSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xl'],
  width: '100%',
});

const itemSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
  width: '100%',
});

const labelSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});

const rowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-lg'],
  width: '100%',
});

const trackSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'relative',
  flex: 1,
  height: 8,
  borderRadius: backrs.radius['radius-full'],
  backgroundColor: backrs.colors['Colors/Background/bg-quaternary'],
  overflow: 'hidden',
});

const fillSx: SxProps<Theme> = ({ backrs }) => ({
  height: '100%',
  borderRadius: backrs.radius['radius-full'],
  backgroundColor: backrs.colors['Brand/500'],
});

const valueSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
  minWidth: 40,
  textAlign: 'right',
});
